module.exports = __webpack_public_path__ + "img/food.773311e0.png";